import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  switchBox: {
    paddingRight:"20px"
  },
  alertBox: {
    '.mantine-Alert-message': {
      color: "#566066", 
      fontSize: "18px",
      lineHeight: "26px"
    }
  },
  inputFieldLabel: {
    '.mantine-TextInput-label': {
      fontSize: "18px",
      lineHeight: "26px"
    },
    '.mantine-TextInput-defaultVariant': {
      fontSize: "18px",
      lineHeight: "26px"
    },
    '.mantine-Textarea-label': {
      fontSize: "18px",
      lineHeight: "26px"
    },
    '.mantine-Textarea-defaultVariant': {
      fontSize: "18px",
      lineHeight: "26px"
    }
  },
  downloadAllFiles: {
    height: "52px",
    fontSize: "24px",
    fontWeight: 400,
    '&:not(.__mantine-ref-loading):disabled': {
      color:"#ffffff",
      backgroundColor: "#AAAFB3",
      boxShadow: "0px 1px 3px rgba(17, 22, 26, 0.1), 0px 2px 1px rgba(17, 22, 26, 0.06), 0px 1px 1px rgba(17, 22, 26, 0.08)",
      borderRadius: "4px",
    }
  },

  floatingContact: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "50px"  
  },

  subtleAction: {
    height: "26px",
    fontSize: "18px",
    fontWeight: 400,
    textTransform: "uppercase",
    padding: 0,
    // Use pseudo-classes just like you would in Sass
    '&:hover': {
      backgroundColor: "transparent",
      color: theme.colors.blue[7]
    },
  },
  formButton: {
    height: "34px",
    fontSize: "18px",
    fontWeight: 400,
    textTransform: "uppercase",
    borderWidth: 2,
  },
  formButtonContactForm: {
    fontSize: "18px",
    fontWeight: 400,
    textTransform: "uppercase",
    borderWidth: 2,
  }
}));

export default useStyles